import reconcilePersistedState from "../../helpers/reconcilePersistedState";

const initialState = {
  paymentPlans: [],
  paymentPlansDynamicData: [],
  selectedPaymentPlanId: -1, // -1 - pay in full, otherwise payment plan id
};

export function paymentPlans(state = initialState, action) {
  switch (action.type) {
    case 'FETCH_LISTING_INFO':
      return {
        ...state,
        paymentPlans: action.data.paymentPlans || [],
      };
    case 'SET_PAYMENT_PLANS_DYNAMIC_DATA':
      return {
        ...state,
        paymentPlansDynamicData: action.data || [],
      };
    case 'SELECT_PAYMENT_PLAN':
      return {
        ...state,
        selectedPaymentPlanId: action.paymentPlanId,
      };
    case 'RESERVATION_CLEARED':
      return {
        ...state,
        selectedPaymentPlanId: -1,
      }
    case 'RECONCILE_PERSISTED_STATE':
      return reconcilePersistedState(state, initialState);
    default:
      return state;
  }
}
